import {Box} from '@mui/material';
import PropsTypes from 'prop-types';

const SidebarWrapper = ({children, ...rest}) => {
  return (
    <Box
      sx={{
        // ... other styles ...
        position: {xs: 'relative', lg: 'fixed'},
        height: '100vh', // LOCK: Exact viewport height
        maxHeight: '100vh', // SHIELD: Prevents content from pushing it taller
        width: 280,
        overflow: 'hidden', // CLEANUP: Hide any leaking content
        display: 'flex', // PREP: Let children use flex logic
        flexDirection: 'column',
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default SidebarWrapper;

SidebarWrapper.propTypes = {
  children: PropsTypes.node,
};
